
import {
  Dialog,
  DialogDescription,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot
} from '@headlessui/vue';
import { mapActions, mapState, mapWritableState } from 'pinia';
import { mixins, Options } from 'vue-class-component';
import { CreatorInfo } from '@/api/creator';
import { DATA_WIDGET_VALUE, States } from '@/common/constants';
import { MSubscribeProvidePropsMixin } from '@/exports/MSubscribeProps';
import { useSubscribeStore } from '@/store/store';

@Options({
  name: 'MSubscribe',
  components: {
    Dialog,
    DialogPanel,
    DialogTitle,
    DialogDescription,
    TransitionRoot,
    TransitionChild
  },
  computed: {
    // gives access to this.count inside the component
    // same as reading from store.count
    ...mapState(useSubscribeStore, [
      'state',
      'email',
      'error',
      'creatorInfo',
      'loading',
      'showPromptSubscribe',
      'isModalOpen',
      'verificationEmailSent',
      'ensOrWallet'
    ]),
    ...mapWritableState(useSubscribeStore, ['email'])
  },
  methods: {
    ...mapActions(useSubscribeStore, [
      'handleAddressChanged',
      'handleAddressAuthenticated',
      'handleAddressUnauthenticated',
      'handleSubscribe',
      'subscribe',
      'handleUnsubscribe',
      'unsubscribe',
      'promptSubscribe',
      'resendVerificationEmail',
      'fetchCreatorInfo',
      'closeModal',
      'openModal',
      'verifyWallet'
    ])
  }
})
export default class MSubscribe extends mixins(MSubscribeProvidePropsMixin) {
  // @dev: don't change this, it makes sure the outer divs get classes that
  //       contain your expected data-widget value no matter what
  DATA_WIDGET_VALUE: string = DATA_WIDGET_VALUE;

  // @dev: start here by replacing the data and functions with your own stuff
  State = States;
  state!: string | undefined;
  email!: string | undefined;
  error!: string | undefined;
  creatorInfo!: CreatorInfo | undefined;
  loading!: boolean;
  showPromptSubscribe!: boolean;
  isModalOpen!: boolean;
  verificationEmailSent!: boolean;

  ensOrWallet!: () => string;
  handleAddressChanged!: () => void;
  closeModal!: () => void;
  openModal!: () => void;
  handleAddressAuthenticated!: () => Promise<void>;
  handleAddressUnauthenticated!: () => void;
  handleSubscribe!: () => Promise<void>;
  subscribe!: () => Promise<void>;
  unsubscribe!: () => Promise<void>;
  handleUnsubscribe!: () => Promise<void>;
  promptSubscribe!: () => void;
  resendVerificationEmail!: () => Promise<void>;
  verifyWallet!: () => Promise<void>;
  fetchCreatorInfo!: (creatorAddress: string) => Promise<void>;

  async mounted(): Promise<void> {
    await this.fetchCreatorInfo(this.creatorAddress);
  }

  created(): void {
    window.addEventListener(window.ManifoldEthereumProvider.ADDRESS_CHANGED, async () => {
      await this.handleAddressChanged();
    });
    window.addEventListener('m-authenticated', async () => {
      await this.handleAddressAuthenticated();
    });
    window.addEventListener('m-unauthenticated', async () => {
      await this.handleAddressUnauthenticated();
    });
    window.addEventListener('m-prompt-subscribe', async () => {
      this.promptSubscribe();
    });
  }

  destroyed(): void {
    window.removeEventListener(window.ManifoldEthereumProvider.ADDRESS_CHANGED, async () => {
      await this.handleAddressChanged();
    });
    window.removeEventListener('m-authenticated', async () => {
      await this.handleAddressAuthenticated();
    });
    window.removeEventListener('m-unauthenticated', async () => {
      await this.handleAddressUnauthenticated();
    });
    window.removeEventListener('m-prompt-subscribe', async () => {
      this.promptSubscribe();
    });
  }
}
